var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRepeatLine = function SvgRepeatLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.6 4.802h13.5a.9.9 0 0 1 .9.9v6.3h-1.8v-5.4H6.6v2.7l-4.5-3.6 4.5-3.6zm10.8 14.4H3.9a.9.9 0 0 1-.9-.9v-6.3h1.8v5.4h12.6v-2.7l4.5 3.6-4.5 3.6z"
  })));
};
export default SvgRepeatLine;